import React from 'react';

import { Box, Button } from '@mui/material'
import FormPaymentJob from '../../../../components/FormPaymentJob/FormPaymentJob';
import PayByCard from '../../../../components/FormPaymentJob/PayByCard/PayByCard';
import config from '../../../../constants/config';
import { JobT } from '../../../../types/Job';
import { TransactionT } from '../../../../types/TransactionT';
import { copyObject, randomId } from '../../../../utils';
import { getCurrentUserId } from '../../../../utils/currentUser';
import {  AxiosInstance } from '../../../../utils/RequestMethods';
import { parseFloatTotal } from '../../../../utils/utilsT';

import { extractVariable } from '../JobUtils';

export type IFormChangingCrewSizeProps = {
    job: JobT
    crewSize: number
    show(): void
    hide(): void
}

const FormChangingCrewSize: React.FC<IFormChangingCrewSizeProps> = (props) => {
    const [tempJob, setTempJob] = React.useState<JobT>(null)
    const changeCrewSizeFee = React.useMemo(() => extractVariable(props.job.companyInfo.variables, "changeCrewSizeFee"), [props.job])
    const currentUserId = getCurrentUserId()
    const [showFormPayment, setShowFormPayment] = React.useState(false);
    const productItemId = randomId(12)
    const [amount, setAmount] = React.useState(1);
    const [productUnits, setProductUnits] = React.useState(1);
    const productRate = changeCrewSizeFee ? changeCrewSizeFee.value : 1

    React.useEffect(() => {

        if (tempJob) {
            // const size = getChangeSize(tempJob, props.crewSize)
            // setProductUnits(size)
            // let _amount = size * productRate
            // setAmount(_amount)
            setValues(tempJob, props.crewSize)
        }
    }, [props.crewSize]);


    /** */
    const setValues = (job: JobT, value: number) => {
        const size = getChangeSize(job, props.crewSize)
        setProductUnits(size)
        let _amount = size * productRate
        setAmount(_amount)
        // return _amount
    }
    /**
     *
     */
    const saveChange = async (crewSize: number, transcation: TransactionT) => {
        const params = {
            crewSize: crewSize,
            transactionId: transcation.id,
        }

        try {
            let res = await AxiosInstance.post(`${config.url.jobs}/${props.job.id}/change-crew-size`, params)


        } catch (error) {

        }
    }

    /**
     *
     * @param job
     * @param value
     * @returns
     */
    const getChangeSize = (job: JobT, value: number) => {
        value = value == undefined ? 0 : value
        const crew = job.crew
        let cloneCrew = copyObject(crew)
        const length = cloneCrew.length
        const size = length - value
        return Math.abs(size)
    }


    return (
        <div>
            <h5>Changing a crew size is ${parseFloatTotal(productRate)} per crew member.</h5>
            {(showFormPayment && props.crewSize > 0) && <div>

                <Box width="100%">

                    <PayByCard
                        productId={props.job.id}
                        userId={currentUserId}
                        productType={"jobs"}

                        paymentItems={[
                            {
                                productItem: "changeCrewSizeFee",
                                amount: amount,
                                productItemId: productItemId,
                                productRate: productRate,
                                productUnits: productUnits
                            }
                        ]}
                        onCompleteProcessing={(transaction) => {
                            // if (props.refresh) {
                            //     props.refresh()
                            // }
                            setShowFormPayment(false)
                            saveChange(props.crewSize, transaction)
                            props.hide()
                        }}

                    />
                </Box>
                {/* <FormPaymentJob
    jobId={props.job.id}
    amount={amount}
    userId={currentUserId}
    productItemId={productItemId}
    productItem={"changeCrewSizeFee"}
    productRate={productRate}
    productUnits={productUnits}
    onCompleteProcessing={(transaction) => {
        // if (props.refresh) {
        //     props.refresh()
        // }

        setShowFormPayment(false)

        saveChange(props.crewSize, transaction)
        props.hide()
    }}
/> */}
            </div>}

            <Box marginLeft={1} marginRight={1}>

                {!showFormPayment ? <Button variant="outlined" color="primary"
                    style={{ paddingTop: 2, marginBottom: 8 }}
                    onClick={() => {
                        setShowFormPayment(true)
                        setTempJob(props.job)
                        setValues(props.job, props.crewSize)
                        props.show()
                    }}>
                    Change crew size?
                </Button>
                    : <Button variant="outlined"
                        style={{ paddingTop: 2, marginBottom: 8 }}
                        onClick={() => {
                            setShowFormPayment(false)
                            props.hide()
                        }}>
                        Cancel
                    </Button>}



            </Box>
        </div>
    );
}

export { FormChangingCrewSize }
